@if (isMulti()) {
  <elcia-multi-dropdown
    [control]="control()"
    [items]="options()"
    [label]="'entity.account-types' | translate"
    [textField]="'name'"
    [valueField]="'id'"
  />
} @else {
  <elcia-dropdown
    [control]="control()"
    [items]="options()"
    [label]="'accounting-account.type' | translate"
    [textField]="'name'"
    [valueField]="'id'"
  />
}
